import React from 'react';
import { Twitter, Linkedin, Link as LinkIcon } from 'lucide-react';
import { toast } from 'sonner';

const SocialShare = ({ title, slug }) => {
  const url = `${window.location.origin}/post/${slug}`;
  const text = encodeURIComponent(title);
  
  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    toast.success('Link copied to clipboard!');
  };

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(url)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
  };

  return (
    <div className="flex items-center space-x-4">
      <span className="text-sm font-medium text-gray-600">Share:</span>
      
      <button
        onClick={() => window.open(shareLinks.twitter, '_blank', 'width=550,height=420')}
        className="p-2 text-gray-600 hover:text-black hover:-translate-y-1 transition-all"
        aria-label="Share on Twitter"
      >
        <Twitter size={20} />
      </button>
      
      <button
        onClick={() => window.open(shareLinks.linkedin, '_blank', 'width=550,height=420')}
        className="p-2 text-gray-600 hover:text-black hover:-translate-y-1 transition-all"
        aria-label="Share on LinkedIn"
      >
        <Linkedin size={20} />
      </button>
      
      <button
        onClick={handleCopyLink}
        className="p-2 text-gray-600 hover:text-black hover:-translate-y-1 transition-all"
        aria-label="Copy link"
      >
        <LinkIcon size={20} />
      </button>
    </div>
  );
};

export default SocialShare;
